import {BaseCopyStamp} from '../../utils/CopyStamp';

export class CopyStamp extends BaseCopyStamp {}
